import { isFeatureEnabled } from "@reliance/feature-flags";
import { getEnvVariable } from "../services/utilityService";

export const envVariables = {
  CONTACT_EMAIL: getEnvVariable("REACT_APP_CONTACT_EMAIL"),
  CONTACT_PHONE_NUMBER: getEnvVariable("REACT_APP_CONTACT_PHONE_NUMBER"),
  SUPPORT_EMAIL: getEnvVariable("REACT_APP_SUPPORT_EMAIL"),
  SUPPORT_FACEBOOK_URL: getEnvVariable("REACT_APP_SUPPORT_FACEBOOK_URL"),
  SUPPORT_FACEBOOK_NAME: getEnvVariable("REACT_APP_SUPPORT_FACEBOOK_NAME"),
  FEATURE_ENABLE_SOCIAL_LINKS: isFeatureEnabled(
    "REACT_APP_FEATURE_ENABLE_SOCIAL_LINKS",
  ),
  STATE_NOMENCLATURE: getEnvVariable("REACT_APP_STATE_NOMENCLATURE"),
  RELIANCE_ANDROID_APP_DOWNLOAD_URL: getEnvVariable(
    "REACT_APP_RELIANCE_ANDROID_APP_DOWNLOAD_URL",
  ),
  RELIANCE_IOS_APP_DOWNLOAD_URL: getEnvVariable(
    "REACT_APP_RELIANCE_IOS_APP_DOWNLOAD_URL",
  ),

  OIDC_ISSUER: getEnvVariable("REACT_APP_OIDC_ISSUER"),
  OIDC_CLIENT_ID: getEnvVariable("REACT_APP_OIDC_CLIENT_ID"),
  OIDC_STORAGE: getEnvVariable("REACT_APP_OIDC_STORAGE"),
  OIDC_REFRESH_THRESHOLD: parseInt(
    getEnvVariable("REACT_APP_OIDC_REFRESH_THRESHOLD") || "300",
    10,
  ), // default to 5 minutes
  OIDC_LOGIN_WITH_SSO:
    getEnvVariable("REACT_APP_OIDC_LOGIN_WITH_SSO") === "true",
  API_BASE_URL: getEnvVariable("REACT_APP_BASE_API_URL"),
  OIDC_TOKEN_NAME: getEnvVariable("REACT_APP_OIDC_TOKEN_NAME"),
  OIDC_REFRESH_TOKEN_NAME: getEnvVariable("REACT_APP_OIDC_REFRESH_TOKEN_NAME"),
  RELIANCE_ANDROID_APP_DOWNLOAD_URL: getEnvVariable(
    "REACT_APP_RELIANCE_ANDROID_APP_DOWNLOAD_URL",
  ),
  RELIANCE_IOS_APP_DOWNLOAD_URL: getEnvVariable(
    "REACT_APP_RELIANCE_IOS_APP_DOWNLOAD_URL",
  ),
  COUNTRY_CURRENCY: getEnvVariable("REACT_APP_COUNTRY_CURRENCY"),
  COUNTRY_LOCALE: getEnvVariable("REACT_APP_COUNTRY_LOCALE"),
  SUPPORTED_LOCALES: getEnvVariable("REACT_APP_SUPPORTED_LOCALES"),
  SUPPORT_WHATSAPP_NUMBER: getEnvVariable("REACT_APP_SUPPORT_WHATSAPP_NUMBER"),
  SUPPORT_PHONE_NUMBER: getEnvVariable("REACT_APP_SUPPORT_PHONE_NUMBER"),
  ACCOUNTS_DASHBOARD_URL: getEnvVariable("REACT_APP_ACCOUNTS_DASHBOARD_URL"),
  LANGUAGE_OPTIONS: getEnvVariable("REACT_APP_FEATURE_LANGUAGE_OPTIONS"),
  SHOW_LOGIN_URL: isFeatureEnabled("REACT_APP_FEATURE_SHOW_LOGIN_URL"),
  ENABLE_MOBILE_APP_DOWNLOADS: isFeatureEnabled(
    "REACT_APP_FEATURE_ENABLE_MOBILE_APP_DOWNLOADS",
  ),
  REACT_APP_FEATURE_ENABLE_KEYCLOAK_SSO: isFeatureEnabled(
    "REACT_APP_FEATURE_ENABLE_KEYCLOAK_SSO",
  ),
  REACT_APP_PATIENT_GATEWAY_URL: getEnvVariable(
    "REACT_APP_PATIENT_GATEWAY_URL",
  ),
};
